
import axios from 'axios';
import { BASE_URL } from './api';

export async function getPageVisitLogs(token) {
    return axios({
        method: 'get',
        url: `${BASE_URL}/page-visit-logs/`,
        headers: {
            'Authorization': `Token ${token}`
        },
    }).then((response) => {
        return response.data;
    }).catch((error) => {
        throw error
    });

}

export async function createPageVisitLog(token, data) {
    // console.log('createPageVisitLog', token, data)
    return axios({
        method: 'post',
        url: `${BASE_URL}/page-visit-logs/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json'
        },
        data: data
    }).then((response) => {
        return response
    }).catch((error) => {
        throw error
    })
}